export default "__VITE_ASSET__B8QSA$ZU__"